
// Tree helpers (read-only), shared by FS and Adjustment consumers
export const hasChildren = (item?: any) => Array.isArray(item?.children) && item.children.length > 0;

export const forEachNode = (nodes: any[], fn: (n: any, level: number) => void, level = 0) => {
  for (const n of nodes || []) {
    fn(n, level);
    if (hasChildren(n)) forEachNode(n.children, fn, level + 1);
  }
};

export const toNestedTree = (list: any[]): any[] => {
  if (!Array.isArray(list) || list.length === 0) return [];
  const hasKids = list.some((n: any) => Array.isArray(n?.children) && n.children.length > 0);
  if (hasKids) return list;
  const roots: any[] = [];
  const stack: any[] = [];
  for (const raw of list) {
    const node = { ...raw, children: [] as any[] };
    const lvl = Number(node.level ?? 0);
    while (stack.length > 0 && Number(stack[stack.length - 1].level ?? 0) >= lvl) stack.pop();
    if (stack.length === 0) roots.push(node); else (stack[stack.length - 1].children = stack[stack.length - 1].children || []).push(node);
    stack.push(node);
  }
  return roots;
};
